import {
  faAnchor,
  faArchive,
  faPerson,
  faSuitcase,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import {
  GenerateSidebar,
  SubdomainOrgIdObject,
} from "./FunctionsAndInterfaces";
import { Page } from "@thoughtspot/visual-embed-sdk";
import { AppEmbedWrapper } from "../components/AppEmbed/AppEmbedWrapper";
import Layout from "../components/Layout";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { appEmbedWrapperCssRules } from "../cssRules";
import { ContactUs } from "../pages/contactus/ContactUs";
import { FinancialModelingPanda } from "../pages/demos/panda/FinancialModelingPanda";
import { SignOut } from "../pages/sign-out/SignOut";
import { Redirect } from "../Redirect";
import { UserCheckTool } from "../features/admin-menu/group-management/UserCheckTool";
import { AdminUserManagement } from "../features/admin-menu/AdminUserManagement";
import { GroupAccessTool } from "../features/admin-menu/group-management/GroupAccessTool";

const orgId: number = 93716433;
const subDomain: string = "pmg";
const nameOfProduct: string = "Panda";
const secureRouteGroups: string[] = ["PMG"];
const editableRightsGroup: string = "PMGEDITINGRIGHTS";
const adminRightsGroup: string = "PanoramaGroupAdmin";

const panoramaUserCreationGroups = [
  //{ value: "PMGEDITINGRIGHTS", label: "Access To Data Tab" },
  { value: "PanoramaGroupAdmin", label: "Group Admin" },
];

export const panoramaObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
  editableRightsGroup: editableRightsGroup,
};

const sidebarMenu = () => {
  return (
    <>
      <GenerateSidebar
        productTitle="Panorama"
        subDomainURL={subDomain}
        dynamicLandingPageObjectsCode={[]}
        otherObjects={{
          sidebarElement: (
            <div>
              <MenuItem>
                <Link to={`/${subDomain}/group-management`}>
                  <div className="sidebar-item">
                    <FontAwesomeIcon className="me-2" icon={faPerson} />
                    Group Management
                  </div>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to={`/${subDomain}/user-management`}>
                  <div className="sidebar-item">
                    <FontAwesomeIcon className="me-2" icon={faAnchor} />
                    User Management
                  </div>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to={`/${subDomain}/user-permission-tool`}>
                  <div className="sidebar-item">
                    <FontAwesomeIcon className="me-2" icon={faSuitcase} />
                    User Permission Tool
                  </div>
                </Link>
              </MenuItem>
              <MenuItem>
                <Link to={`/${subDomain}/group-permission-tool`}>
                  <div className="sidebar-item">
                    <FontAwesomeIcon className="me-2" icon={faArchive} />
                    Group Permission Tool
                  </div>
                </Link>
              </MenuItem>
            </div>
          ),
          groupPermission: adminRightsGroup,
        }}
      />
    </>
  );
};

export const pmgRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}`,
      element: <Redirect redirectTo={`/${subDomain}/product`} />,
    },
    {
      path: `/${subDomain}/product`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AppEmbedWrapper
              cssRules={appEmbedWrapperCssRules}
              breakPoint={DefaultSidebarBreakpoint}
              showPrimaryNavbar={true}
              disableProfileAndHelp={true}
              className="ts-full-app h-100"
              pageId={Page.Liveboards}
              orgObject={panoramaObject}
              disableEditButtonArray={[]}
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/financialmodel`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<FinancialModelingPanda />}
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/user-permission-tool`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <UserCheckTool
              cognitoGroup={secureRouteGroups[0]}
              userShouldHaveNames={true}
              orgId={panoramaObject.orgID}
              mode="User"
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/group-permission-tool`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <UserCheckTool
              cognitoGroup={secureRouteGroups[0]}
              userShouldHaveNames={false}
              orgId={panoramaObject.orgID}
              mode="Group"
            />
          }
          groups={secureRouteGroups}
        />
      ),
    },
    {
      path: `/${subDomain}/user-management`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={
            <AdminUserManagement
              preferredUsernameIsEmail={true}
              cognitoGroup={secureRouteGroups[0]}
              availableCognitoGroupsForCreation={panoramaUserCreationGroups}
              disableEdit={false}
              disableDelete={false}
              rlsIsEnabled={true}
            />
          }
          groups={[adminRightsGroup]}
        />
      ),
    },
    {
      path: `/${subDomain}/group-management`,
      element: (
        <SecureRoute
          productName={nameOfProduct}
          element={<GroupAccessTool enableDescriptions={true} orgId={orgId} />}
          groups={[adminRightsGroup]}
        />
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
